(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
const regionDefault = document.getElementById('catalog-region-default');
if (regionDefault) {
  const returnUrl = new URL(window.location.href);
  returnUrl.searchParams.delete('country');
  const attemptKey = 'catalog-region-default-attempt';
  let shouldSubmit = true;
  try {
    const lastAttempt = Number(sessionStorage.getItem(attemptKey) || 0);
    shouldSubmit = Date.now() - lastAttempt > 30000;
    if (shouldSubmit) sessionStorage.setItem(attemptKey, String(Date.now()));
  } catch {}
  if (shouldSubmit) {
    const returnInput = regionDefault.querySelector('[name="return_to"]');
    if (returnInput) returnInput.value = returnUrl.pathname + returnUrl.search;
    regionDefault.submit();
  }
}

  } catch(e) { console.error(e); }
})();
})();
